const localeEs = {
  UDE_ACADEMIES_ERROR: 'Ocurrió un error al obtener tus academias',
};
export default localeEs;
